// src/components/common/DatePickerField.jsx
import React, { useRef } from 'react'
import {  silverIcon } from '../../assets/icons' // adjust path as needed
import classes from './NewDatePicker.module.css' // create this file

const DatePickerField = ({
  value, // ISO string e.g. "2025-02-17"
  onChange, // (dateString: string) => void
  // label = '',
  placeholder = 'Choose a date',
  min, // optional: "YYYY-MM-DD"
  max, // optional: "YYYY-MM-DD"
  disabled = false,
  required = false,
  className = '',
  inputClassName = '',
  containerClassName = '',
  format = (dateStr) => {
    if (!dateStr) return placeholder
    const date = new Date(dateStr)
    if (isNaN(date)) return placeholder
    return `On ${date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
    })}`
  },
  ...rest
}) => {
  const inputRef = useRef(null)

  const handleClick = () => {
    if (disabled || !inputRef.current) return

    // Mobile browsers (iOS/Android) need focus + delayed click
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      inputRef.current.focus()
      setTimeout(() => {
        inputRef.current.click()
      }, 100)
    } else {
      // Desktop: use showPicker() if available (Chrome/Edge), else fallback
      if (inputRef.current.showPicker) {
        inputRef.current.showPicker()
      } else {
        inputRef.current.click()
      }
    }
  }

  const handleChange = (e) => {
    const newValue = e.target.value // "YYYY-MM-DD"
    onChange(newValue)
  }

  // Display value
  const displayValue = format(value)

  return (
    <div className={`${classes.dateWrapper} ${containerClassName}`}>
      {/* {label && (
        <label className={classes.label}>
          {label}
          {required && <span className={classes.required}>*</span>}
        </label>
      )} */}

      {/* Hidden native input */}
      <input
        type="date"
        ref={inputRef}
        value={value || ''}
        onChange={handleChange}
        min={min}
        max={max}
        disabled={disabled}
        required={required}
        className={`${classes.nativeInput} ${inputClassName}`}
        {...rest}
      />

      {/* Visible custom field */}
      <div
        className={`${classes.dateContainer} ${className}`}
        onClick={handleClick}
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
      >
        <div className={classes.dateContent}>
          <img src={silverIcon} alt="Calendar" className={classes.calendarIcon} />

          <span className={`${classes.dateText} ${!value ? classes.placeholder : ''}`}>
            {displayValue}
          </span>
        </div>
      </div>
    </div>
  )
}

export default DatePickerField
